import React, { useEffect, useState } from "react";

export function Header({ logoPath }) {
  const [isLeda, setIsLeda] = useState(false);
  useEffect(() => {
    // Get the current URL's search params (everything after the '?')
    const queryParams = new URLSearchParams(window.location.search);

    // Get the 'page' parameter
    const page = queryParams.get("page");
    if (page && page.toLowerCase() === "leda") {
      setIsLeda(true);
    }
  }, []);
  return (
    <header className="sticky top-0 w-full border-b border-gray-800 bg-white backdrop-blur-sm">
      <div className="flex h-20 items-center justify-between px-4">
        <img className="h-16 cursor-pointer" src={logoPath} alt="Logo" />

        {isLeda ? (
          <nav className="space-x-4 text-sm md:text-lg">
            <a
              href={`${process.env.REACT_APP_SITE_URL}leda-group/`}
              className="hover:underline"
            >
              Home
            </a>
            <a
              href={`${process.env.REACT_APP_SITE_URL}682afc064e30fe1a6c969ab3/career?page=leda`}
              className="hover:underline"
            >
              Careers
            </a>
            <a
              href={`${process.env.REACT_APP_SITE_URL}leda-group/about`}
              className="hover:underline"
            >
              About LEDA
            </a>
          </nav>
        ) : (
          ""
        )}
      </div>
    </header>
  );
}

export default Header;
